var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('path', {
      attrs: {
        "d": "M43.807 29.03a11.202 11.202 0 00-7.891 3.19 10.906 10.906 0 00-3.23 7.721v14.894h22.119V39.94a10.829 10.829 0 00-3.245-7.722 11.155 11.155 0 00-7.753-3.187v-.002zm-.182 22.118l-.317-7.088h-5.706l7.474-8.886.636 5.726 5.406.178-7.553 10.07h.06zM29 57.914c-.004-.49.17-.96.486-1.307.301-.342.734-.54 1.19-.543h27.37c.441.005.866.2 1.182.537.311.353.486.824.492 1.313 0 1.012-.749 1.834-1.67 1.836H30.677a1.603 1.603 0 01-1.186-.538A1.928 1.928 0 0129 57.916v-.002z",
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};